import { LinkOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

import { Text } from '@suntex.core/text';
import { asURL } from '@suntex.core/text/extensions';
import { useClassicDomain } from '@suntex.fim/framework';
import { Button } from '@suntex.fim/ui';

export interface ClassicLinkProps {
  classicPath: string;
  children?: ReactNode;
}

export function ClassicLink({ classicPath, children }: ClassicLinkProps) {
  const { classicDomain } = useClassicDomain();
  if (!classicDomain) return null;

  const url = Text.of(classicDomain + classicPath).extend(asURL()).parsed.href;

  return (
    <Button
      intent="danger"
      icon={<LinkOutlined />}
      onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
    >
      {children ?? 'Open in FIM classic'}
    </Button>
  );
}
